export enum QuantityTypesEnum
{
    Pallets = 1,
    Units = 2,
    EnterNumberOfLabels = 3
}